import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IoCopy, IoCopyOutline } from 'react-icons/io5';
import * as Ui from './CopyButton.styles';

const CopyButton = ({ value, iconSize = 20, ...props }) => {
  const { t } = useTranslation('app');
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <Ui.Button
      {...props}
      type="button"
      onClick={handleCopy}
      $copied={copied}
      aria-label={t('copy')}
    >
      {copied ? <IoCopy size={iconSize} color="#be1622" /> : <IoCopyOutline size={iconSize} />}
    </Ui.Button>
  );
};

CopyButton.propTypes = {
  value: PropTypes.string.isRequired,
  size: PropTypes.number,
};

export default CopyButton;
